import React from "react";

export type FilterColors = "sky" | "emerald" | "indigo" | "rose" | "amber";

interface FilterButtonProps {
  children: React.ReactNode;
  color: FilterColors;
  isActive: boolean;
  onClick: () => void;
}

export const CalendarFilterButton = ({ children, onClick, color, isActive }: FilterButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`btn-sm border-slate-200 bg-white text-slate-500 hover:border-slate-300 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-400 dark:hover:border-slate-600 ${isActive ? "" : "opacity-50"}`}
    >
      <div className={`h-3.5 w-1 ${colorsClasses[color]} shrink-0`}></div>
      <span className="ml-1.5">{children}</span>
    </button>
  );
};

const colorsClasses = {
  sky: "bg-sky-500",
  emerald: "bg-emerald-500",
  indigo: "bg-indigo-500",
  rose: "bg-rose-400",
  amber: "bg-amber-500",
};
